import {Space} from "antd";
import {StoreServiceGenInfoFormFieldsProps} from "./types";
import {ServiceGenInfoNameFormField} from "./name-form-field";
import {ServiceGenInfoDescriptionFormField} from "./description-form-field";

export function ServiceGenInfoFormFields({
  nameFieldId,
  nameFieldLabel,
  nameFieldPlaceholder,
  descriptionFieldId,
  descriptionFieldLabel,
  descriptionFieldPlaceholder,
}: StoreServiceGenInfoFormFieldsProps) {
  return (
    <div>
      <Space size={16} direction="vertical" style={{display: "flex"}}>
        <ServiceGenInfoNameFormField
          id={nameFieldId}
          label={nameFieldLabel}
          placeholder={nameFieldPlaceholder}
        />
        <ServiceGenInfoDescriptionFormField
          id={descriptionFieldId}
          label={descriptionFieldLabel}
          placeholder={descriptionFieldPlaceholder}
        />
      </Space>
    </div>
  );
}
